import * as ActionTypes from '../../actions/allActions'

const signInInit = { email: "", password: "", remember_me: false }
const signin = (state = signInInit, action) => {
	switch (action.type) {
		case ActionTypes.SIGNIN_DATACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.LOGOUT:
			return signInInit
		default:
			return state
	}
}

export default signin


// WEBPACK FOOTER //
// ./src/reducers/data/signin.js